<template>
  <section id="main">
    <div class="container">
      <div class="row title-text">
        <h1>八斗里</h1>
      </div>
      <div class="row">
        <div class="col-lg-12 content-box">
          <iframe class="embed-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7223.449215743218!2d121.79401064716455!3d25.144999760978173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x345d4f775f218ba1%3A0x3f158fd8cc8818f!2zMjAy5Z-66ZqG5biC5Lit5q2j5Y2A5YWr5paX6YeM!5e0!3m2!1szh-TW!2stw!4v1722842672856!5m2!1szh-TW!2stw" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="context">
            <p>
              八斗里擁有一整條海岸線，從古至今，八斗里居民不管是產業面還是生活面都圍繞著海洋，與海共存。
            </p>
            <p>
              就產業面來看，一直以來，八斗里主要的產業都是漁業。居民們使用的是小型漁船，以近海捕撈漁業為主，而在岸上的產業也多與漁業相關，通常是一些簡單的漁產加工（傳統漁寮）。
  就生活面而言，八斗里居民的生活也全然離不開海洋，在八斗里的幾個廟宇中，都有供奉媽祖，可見他們的生活與工作都和海洋息息相關。目前八斗里的觀光發展也離不開海洋，例如薯榔海水染體驗、觀光漁港等等。
            </p>
            <p>
              此地的建築物還保有許多傳統的文化，例如咾咕石建築、還在運作中的傳統漁寮、少數已經無人居住整理的老磚屋等。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="each-site">
    <div class="container">
      <div class="row title-text">
        <h1 class="aos-init aos-animate" data-aos="fade-right">景點介紹</h1>
      </div>
      <div class="row">
        <div class="col-md-6 site-box">
          <img class="site-img mb-3 aos-init aos-animate" src="@/assets/聖斗宮.jpg" alt="" data-aos="fade-in">
          <div class="context">
            <p>聖斗宮，主祀關聖帝君，廟的外觀以紅黃作為主色調，廟裡供奉諸多神像，會舉辦遶境活動及鄉里書法比賽等促進里民感情。</p>
          </div>
        </div>
        <div class="col-md-6 site-box aos-init aos-animate">
          <img class="site-img" src="@/assets/忘憂居.jpg" alt="" data-aos="fade-in">
          <div class="context">
            <p>忘憂居是一棟兩層樓紅磚老厝，建於1933年，為杜氏家族所建。現屋主為杜家第七代杜世國，他將忘憂居重新裝潢，改建為餐廳。</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 site-box aos-init aos-animate">
          <img class="site-img" src="@/assets/度天宮.jpg" alt="" data-aos="fade-in">
          <div class="context">
            <p>度天宮位於面對八斗子漁港的半山腰，主神媽祖，是當地討海人的信仰中心，香火鼎盛，每年農曆3月23日媽祖聖誕都會舉辦繞境遊行活動，非常熱鬧。</p>
            
          </div>
        </div>
        <div class="col-md-6 site-box aos-init aos-animate">
          <img class="site-img" src="@/assets/大坪海岸.jpg" alt="" data-aos="fade-in">
          <div class="context">
            <p>大坪海岸是經歷數萬年海浪沖擊，形成的典型海蝕平台，甚至還有海蝕洞、豆腐岩等瑰麗又獨特的海蝕奇觀，讓人可悠閒的漫步欣賞絕美海景。</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer>
    <div class="container">
      <div class="row">
        <p class="text-center">©2024 八斗故事村</p>
      </div>
    </div>
  </footer>
</template>

<script>
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100..900&display=swap');
.title-text {
  margin-top: 3rem;
  margin-left: 3rem;
}

#main {
  font-family: "Noto Sans TC", sans-serif;
  h1 {
    font-weight: 600;
  }
}


.embed-map {
  width: 100%;
  height: 50vh;
  border-radius: 20px;
  padding: 0.5rem;
  margin-bottom: 1rem;
}
.content-box {
  padding: 2rem 3rem;
}
.context {
  padding: 0.5rem;
  font-size: 18px;
}
.site-img {
  width: 100%;
  padding: 0.5rem;
  border-radius: 15px;
}

.site-box {
  margin-top: 4rem;
  padding: 0 2rem;
}

#each-site {
  font-family: "Noto Sans TC", sans-serif;
  background-color: #7bc9dd43;
  padding-top: 1rem;
  h1 {
    font-weight: 600;
    color: #2c2c2c;
  }
}

footer {
  padding: 0.5rem;
  background: #7bcadd;
  color: #fff;
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 600;
}

</style>
